"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryOperationNodes = void 0;
const bus_query_operation_1 = require("@comunica/bus-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
const utils_query_operation_1 = require("@comunica/utils-query-operation");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor that handles SPARQL nodes operations.
 */
class ActorQueryOperationNodes extends bus_query_operation_1.ActorQueryOperationTypedMediated {
    constructor(args) {
        super(args, 'nodes');
    }
    async testOperation(operation, _context) {
        if (!(0, utils_query_operation_1.getOperationSource)(operation)) {
            return (0, core_1.failTest)(`Actor ${this.name} requires an operation with source annotation.`);
        }
        return (0, core_1.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const source = (0, utils_query_operation_1.getOperationSource)(operation);
        // We run the query DISTINCT { { ?VAR ?p ?x ?g } UNION { ?x ?p ?VAR ?g } }, to get all possible nodes in the graph
        const varP = dataFactory.variable('__p');
        const varX = dataFactory.variable('__x');
        const result = (0, utils_query_operation_1.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            context,
            operation: algebraFactory.createDistinct(algebraFactory.createUnion([
                (0, utils_query_operation_1.assignOperationSource)(algebraFactory.createPattern(operation.variable, varP, varX, operation.graph), source),
                (0, utils_query_operation_1.assignOperationSource)(algebraFactory.createPattern(varX, varP, operation.variable, operation.graph), source),
            ])),
        }));
        const bindingsStream = result.bindingsStream
            .map(bindings => bindings.delete(varP).delete(varX));
        return { type: 'bindings', bindingsStream, metadata: result.metadata };
    }
}
exports.ActorQueryOperationNodes = ActorQueryOperationNodes;
//# sourceMappingURL=ActorQueryOperationNodes.js.map